import styled from 'styled-components';
export const Title = styled.div `
  display: block;
  margin-bottom: .5rem;
  ${({ theme: { sessionHeaderTitle } }) => sessionHeaderTitle}
`;
export const Copy = styled.div `
  ${({ theme: { sessionHeaderCopy } }) => sessionHeaderCopy}
`;
export const Wrapper = styled.div `
  padding: .8rem 1rem;
  ${({ theme: { sessionHeader } }) => sessionHeader}
`;
